import { RootState } from "app/store";
import { selectRosterDisplayName, selectRosterOrgId } from "selectors/Roster";

interface RosterIdHaver {
  rosterId: string;
}
export function selectWithDisplay<T extends RosterIdHaver>(
  state: RootState,
  items: T[],
  tournamentId: string
) {
  return items.map((r) => ({
    record: r,
    orgId: selectRosterOrgId(state, r.rosterId, tournamentId),
    displayName: selectRosterDisplayName(state, r.rosterId, tournamentId),
  }));
}
